import { render } from "./Standard.vue?vue&type=template&id=d8c0043a&ts=true"
import script from "./Standard.vue?vue&type=script&lang=ts"
export * from "./Standard.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__